<template>
  <span class="scaling-svg-container">
    <svg
      id="Icon_Checkmark"
      data-name="Icon/Checkmark"
      xmlns="http://www.w3.org/2000/svg"
      width="14.376"
      height="10.782"
      viewBox="0 0 14.376 10.782"
      class="scaling-svg"
    >
      <path
        id="Icon_Icon_Checkmark"
        data-name="Icon/Icon/Checkmark"
        d="M5.268,10.782a.9.9,0,0,1-.655-.283L.244,5.845a.9.9,0,1,1,1.309-1.23L5.259,8.561,12.814.293A.9.9,0,1,1,14.141,1.5L5.931,10.489a.9.9,0,0,1-.657.293Z"
        transform="translate(0 0)"
      />
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class ConfirmIcon extends Vue {}
</script>

<style>
</style>
